module.exports = __webpack_public_path__ + "img/logo_headway_blue_2.f8e69351.png";